/**
 * Toggles the overlay for the mobile main navigation.
 * Sets the required CSS classes and WAI-ARIA states.
 * It is toggled by the hamburger icon.
 *
 * 1. Shows the nav overlay.
 * 2. Used to set fixed position for page header.
 * 3. Transforms hamburger icon.
 */

const initMenuOverlay = () => {
    const hamburger = document.getElementById('js_menuToggle'),
        overlay = document.getElementById('js_menuOverlay'),
        body = document.body,
        classes = {
            open: 'is-open', // 1
            openBody: 'has-open-overlay', // 2
            active: 'is-active', // 3
            closing: 'is-closing',
        };

    function onEndTransitionFn(ev) {
        if (ev.propertyName !== 'visibility') {
            return;
        }

        this.removeEventListener('transitionend', onEndTransitionFn);
        overlay.classList.remove(classes.closing);
    }

    const toggleOverlay = () => {
        if (overlay.classList.contains(classes.open)) {
            overlay.classList.remove(classes.open);
            body.classList.remove(classes.openBody);
            overlay.classList.add(classes.closing);

            overlay.addEventListener('transitionend', onEndTransitionFn);

            hamburger.classList.remove(classes.active);
            hamburger.setAttribute('aria-expanded', 'false');
        } else if (!overlay.classList.contains(classes.closing)) {
            overlay.classList.add(classes.open);
            body.classList.add(classes.openBody);
            hamburger.classList.add(classes.active);
            hamburger.setAttribute('aria-expanded', 'true');
        }
    };

    hamburger.addEventListener('click', toggleOverlay);
};

document.addEventListener('DOMContentLoaded', () => {
    initMenuOverlay();
});
